import React from "react";
import { Card, CardContent, Typography, IconButton, Menu, MenuItem } from "@mui/material";
import { MoreVert, Edit, NotInterested, CheckCircleOutline, Delete } from "@mui/icons-material";
import { withTranslation } from "react-i18next";

import styles from "./CompanyCard.module.scss";
import { formatKennitala } from "utils/kennitalaFormatter";

const CompanyCard = ({ company, onStatusChange, onEdit, onDelete, t }) => {
    const [anchorEl, setAnchorEl] = React.useState(null);

    const hasMenu = Boolean(onStatusChange || onDelete || onEdit);

    const handleMenuClick = (event) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = (event) => {
        if (event) {
            event.stopPropagation();
        }
        setAnchorEl(null);
    };

    const handleStatusChange = (event, status) => {
        event.stopPropagation();
        if (onStatusChange) onStatusChange(company.id, status);
        handleMenuClose();
    };

    const handleEdit = (event) => {
        event.stopPropagation();
        if (onEdit) onEdit(company);
        handleMenuClose();
    };

    const handleDelete = (event) => {
        event.stopPropagation();
        if (onDelete) onDelete(company);
        handleMenuClose();
    };

    const handleCardClick = () => {
        if (onEdit) onEdit(company);
    };

    return (
        <div
            className={`${styles.cardContainer} ${company.disabled ? styles.disabled : ""}`}
            onClick={handleCardClick}
        >
            <Card className={styles.card}>
                <div className={styles.badgesContainer}>
                    <div className={styles.offersBadge}>
                        {`${company.torgid_offers_count} / ${company.offer_limit}`}
                    </div>
                </div>
                {hasMenu && (
                    <IconButton className={styles.menuButton} onClick={handleMenuClick}>
                        <MoreVert />
                    </IconButton>
                )}
                <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
                    {onStatusChange && (
                        <MenuItem
                            onClick={(e) =>
                                handleStatusChange(e, company.disabled ? "enable" : "disable")
                            }
                        >
                            {company.disabled ? (
                                <>
                                    <CheckCircleOutline style={{ marginRight: "8px" }} />
                                    {t("enable")}
                                </>
                            ) : (
                                <>
                                    <NotInterested style={{ marginRight: "8px" }} />
                                    {t("disable")}
                                </>
                            )}
                        </MenuItem>
                    )}
                    {onEdit && (
                        <MenuItem onClick={handleEdit}>
                            <Edit style={{ marginRight: "8px" }} />
                            {t("edit")}
                        </MenuItem>
                    )}
                    {onDelete && (
                        <MenuItem onClick={handleDelete}>
                            <Delete style={{ marginRight: "8px" }} />
                            {t("delete")}
                        </MenuItem>
                    )}
                </Menu>
                <div className={styles.logoContainer}>
                    <img
                        src={company.logo || "/spara-placeholder.png"}
                        alt={company.name}
                        onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = "/spara-placeholder.png";
                        }}
                    />
                    {company.disabled && (
                        <div className={styles.disabledBadge}>{t("disabled")}</div>
                    )}
                </div>
                <div className={styles.divider} />
                <CardContent className={styles.content}>
                    {company.type && (
                        <div className={styles.typeBadge} data-type={company.type.toLowerCase()}>
                            {company.type}
                        </div>
                    )}
                    <Typography variant="h6" className={styles.name}>
                        {company.name}
                    </Typography>
                    <Typography variant="body2" className={styles.kennitala}>
                        {formatKennitala(company.kennitala)}
                    </Typography>
                </CardContent>
            </Card>
        </div>
    );
};

export default withTranslation()(CompanyCard);
